import actions from './actions'

export default function ProtocolReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
      }
    case actions.LIST_PROTOCOL:
      return {
        ...state,
        result: action.result,
        loading: false,
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.message,
      }
    default:
      return state
  }
}
